import React, { useState } from 'react';
import { useImmer } from 'use-immer';
import XLSX from 'xlsx';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { Card, Form, Jumbotron, Col, Button } from 'react-bootstrap';
import DropdownMultiselect from 'react-multiselect-dropdown-bootstrap';
import FormControls from '../../controls/formControls';
import { AdminMetricsService, CustomerAccountService } from '../../services';
import { TabList, TabItem } from '../../controls';
import { useEffect } from 'react';
import ReportParametersContainer from '../../controls/report/ReportParametersContainer';
import CustomerSelector from '../../controls/report/selectors/CustomerSelector';
import DateSelector from '../../controls/report/selectors/DateSelector';

const monthPrevious = (last = false) => {
    var d = new Date();
    d.setDate(0);
    if (!last) {
        d.setDate(1);
    }
    return d;
}

//const AdminReports = () => {

//    const runReport = (values) => {
//        //do something here
//    }

//    return (
//        <Card className="h-80">
//            <Card.Header className="d-flex align-items-center">
//                <div className="mr-auto" >Assessment Metrics</div>
//                <div className="card-btn-group">
//                </div>
//            </Card.Header>
//            <Card.Body>
//                <ReportParametersContainer runReport={runReport} >
//                    <CustomerSelector name="selectedAccounts" label="Accounts" initialValue={null} />
//                    {/*<DateSelector name="dateFrom" label="Start Date" initialValue={monthPrevious().toISOString().split('T')[0]} />*/}
//                    <DateSelector name="dateTo" label="End Date" initialValue={monthPrevious(true).toISOString().split('T')[0]} />
//                </ReportParametersContainer>
//            </Card.Body>
//        </Card>
//    )
//}

const CodingEventLocatorReport = () => {

    const [metrics, setMetrics] = useState([]);
    const [customers, setCustomers] = useState([
        { value: 20426, label: 'Prisma Columbia' },
        { value: 20423, label: 'Prisma Greenville' },
        { value: 20425, label: 'Prisma Tuomey' }]);
    const [initFromDate, setInitFromDate] = useState(null);
    const [initToDate, setInitToDate] = useState(null);

    //const customers = [
    //    {key: 20426, label: 'Prisma Columbia' },
    //    {key: 20423, label: 'Prisma Greenville' },
    //    {key: 20425, label: 'Prisma Tuomey' }]



    useEffect(() => {
        const initFromDate = monthPrevious().toISOString().split('T')[0];
        const initToDate = monthPrevious(true).toISOString().split('T')[0];
        setInitFromDate(initFromDate);
        setInitToDate(initToDate);
        getCustomerList();
    }, [])

    const getCustomerList = async () => {
        const customerService = new CustomerAccountService();
        var results = await customerService.getCustomerRef(false, true);
        let accounts = results.model.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1);
        let accountList = accounts.map((acc) => (
            {
                value: acc.id,
                label: acc.name
            }
        ));
        setCustomers(accountList);
    }

    const assessmentMetricsValidationSchema = {
        selectedAccounts: Yup.array().min(1, 'You must select at least one account'),
        dateFrom: Yup.date().nullable().required('You must select a from date'),
        dateTo: Yup.date().nullable().required('You must select an end date').min(
            Yup.ref('dateFrom'), 'End date cannot be before start date.'
        )
    };

    const formik = useFormik({
        initialValues: { selectedAccounts: [], dateFrom: initFromDate, dateTo: initToDate },
        validationSchema: Yup.object().shape(assessmentMetricsValidationSchema),
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting, setErrors, setStatus, resetForm }) => {
            //await saveCustomer(values);
            await getMetrics(values);
            setSubmitting(false);
        }
    });

    const getMetrics = async (values) => {
        const { selectedAccounts, dateFrom, dateTo } = values;
        const metricsService = new AdminMetricsService();
        var results = await metricsService.assessmentMetrics(selectedAccounts, dateFrom, dateTo);
        if (results.result) {
            const metrics = results.model;
            const accounts = Object.keys(metrics);
            const newResults = accounts.filter(acc => acc !== "All").map(account => (
                { accountName: account, data: metrics[account] }
            ));
            const wb = XLSX.utils.book_new();

            if (metrics.All !== undefined) {
                const ws = XLSX.utils.json_to_sheet(metrics["All"].allResults);
                XLSX.utils.book_append_sheet(wb, ws, "All");
            }

            if (newResults.length > 0) {
                newResults.forEach(account => {
                    const accName = account.accountName.slice(0, 22)
                    const ws = XLSX.utils.json_to_sheet(account.data.accountResults);
                    XLSX.utils.book_append_sheet(wb, ws, accName);
                    const ws2 = XLSX.utils.json_to_sheet(account.data.clinicianResults);
                    XLSX.utils.book_append_sheet(wb, ws2, accName + '-Clin');
                    const ws3 = XLSX.utils.json_to_sheet(account.data.clinicalManagerResults);
                    XLSX.utils.book_append_sheet(wb, ws3, accName + '-Clin Man');
                })

                // build workbook name
                const wbNameArray = accounts.map(account => account.replaceAll(' ', '').substr(0, 20));
                const wbName = wbNameArray.join('_');

                /* generate XLSX file and send to client */
                XLSX.writeFile(wb, wbName + "_" + dateFrom + "_" + dateTo + ".xlsx")
            } else {
                alert("No results returned.");
            }

            setMetrics(results);
        } else {
            alert(results.message);
        }
    }

    return (
        <Card className="h-80">
            <Card.Header className="d-flex align-items-center">
                <div className="mr-auto" >Assessment Metrics</div>
                <div className="card-btn-group">
                </div>
            </Card.Header>
            <Card.Body>
                {/*{JSON.stringify(formik.values, null, 2)}*/}
                <Jumbotron className="pt-3 pb-2">
                    <Form.Row>
                        <Form.Group as={Col} lg="6" md="12">
                            <FormControls.Multiselect
                                options={customers}
                                name="selectedAccounts"
                                label="Accounts"
                                formHandler={formik}
                            />
                        </Form.Group>
                        <Form.Group as={Col} lg="3" md="12">
                            <FormControls.Textbox
                                label="Start Date"
                                type="date"
                                name="dateFrom"
                                formHandler={formik} />
                        </Form.Group>
                        <Form.Group as={Col} lg="3" md="12">
                            <FormControls.Textbox
                                label="End Date"
                                type="date"
                                name="dateTo"
                                formHandler={formik} />
                        </Form.Group>
                        <Form.Group as={Col} lg="4" md="12">
                            <Button variant="success" onClick={() => formik.submitForm()}>Run</Button>
                        </Form.Group>
                    </Form.Row>
                </Jumbotron>
            </Card.Body>
        </Card>
    )
}

export default CodingEventLocatorReport;